import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import Report from "@/services/analytics/report";

export interface DashboardStatsParams {
  todayStartDate: Date;
  todayEndDate: Date;
  offset: number;
  startDate: string;
  endDate: string;
  organizationId: string;
  bucketOwnerId?: string;
  activityOwnerId?: string;
}

export function useDashboardStats(
  params: Ref<DashboardStatsParams | null> | DashboardStatsParams | null
) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["dashboardStats", "disabled"];
    return [
      "dashboardStats",
      p.organizationId,
      p.startDate,
      p.endDate,
      p.bucketOwnerId,
      p.activityOwnerId,
    ];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await Report.getDashboardStats(p);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to load dashboard statistics");
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
